
export enum ClassKey {
    STORAGE = 'storage',
    VIRTUALIZATION = 'virtualization',
    CLOUD = 'cloud',
    DATABASE = 'database',
    SAN = 'san',
    CONTAINER = 'container',
    LAN = 'lan',
    BACKUP = 'backup',
    SERVERSP = 'serversp',
    TAPE = 'tape',
}

export const classDefinitionLabel = {
    [ClassKey.STORAGE]: 'Storage',
    [ClassKey.VIRTUALIZATION]: 'Virtualization',
    [ClassKey.CLOUD]: 'Cloud',
    [ClassKey.DATABASE]: 'Database',
    [ClassKey.SAN]: 'SAN',
    [ClassKey.LAN]: 'LAN',
    [ClassKey.CONTAINER]: 'Container',
    [ClassKey.BACKUP]: 'Backup',
    [ClassKey.SERVERSP]: 'Server SP',
    [ClassKey.TAPE]: 'Tape',
}